import { render } from "./TechnologiesStack.vue?vue&type=template&id=074f1d78&ts=true"
import script from "./TechnologiesStack.vue?vue&type=script&lang=ts"
export * from "./TechnologiesStack.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__